<div
  (click)="isClickable() ? clicked.emit() : undefined"
  [class.flex-col]="layout() === 'VERTICAL'"
  [class.flex-row]="layout() === 'HORIZONTAL'"
  [class.w-full]="fullWidth()"
  [class.w-max]="!fullWidth()"
  [class]="twBackground()"
  class="group flex min-w-64 gap-1 rounded-xl p-1 transition-colors select-none"
>
  @if (image(); as image) {
    <img
      (dragstart)="(false)"
      [alt]="text()"
      [class]="{
        grayscale: state() === 'DISABLED',
      }"
      [src]="image"
      class="w-3xs rounded-lg transition-colors select-none xl:w-xs"
    />
  }

  @if (audio(); as audio) {
    <div
      class="font-family-din w-full place-content-center rounded-lg p-2 text-center text-4xl font-normal transition-colors"
      [class]="{
        'bg-card-background': state() === 'DEFAULT',
        'bg-slate-100': state() === 'DISABLED',
        'bg-red-100': state() === 'INCORRECT',
        'bg-emerald-100': state() === 'CORRECT',
        'text-emerald-500': state() === 'CORRECT',
        'text-red-500': state() === 'INCORRECT',
        'text-text-primary': state() === 'DEFAULT',
        'text-slate-300': state() === 'DISABLED',
        'group-hover:text-blue-500': isClickable() && state() === 'DEFAULT',
      }"
    >
      <rid-audio-button #audioButton [src]="audio" [size]="image() ? 'SMALL' : 'XSMALL'" />
    </div>
  }

  @if (text(); as text) {
    <div
      [class]="{
        'bg-card-background': state() === 'DEFAULT',
        'bg-slate-100': state() === 'DISABLED',
        'bg-red-100': state() === 'INCORRECT',
        'bg-emerald-100': state() === 'CORRECT',
        'text-emerald-500': state() === 'CORRECT',
        'text-red-500': state() === 'INCORRECT',
        'text-text-primary': state() === 'DEFAULT',
        'text-slate-300': state() === 'DISABLED',
        'group-hover:text-blue-500': isClickable() && state() === 'DEFAULT',
      }"
      class="font-family-din w-full place-content-center rounded-lg p-4 text-center text-4xl font-normal transition-colors"
    >
      {{ text }}
    </div>
  }

  <ng-content />
</div>
